import React, {FC} from "react";
import {ButtonProps} from "./Button-types";
import {Root, Text, Loader} from "./Button-styles";


const Button: FC<ButtonProps> = (props) => {
    const {text, onClick, isActive = true, isLoading = false, size = "normal"} = props;

    return (
        <Root $isActive={isActive} disabled={isLoading} onClick={onClick}>
            <Loader $isLoading={isLoading}/>

            <Text $isLoading={isLoading} $size={size}>{text}</Text>
        </Root>
    )
}

export default Button;
